(ns pfo.chat.controller
  (:require-macros [pfo.macros :refer [defcontroller]])
  (:require
   [pfo.api :as api  :refer [process-error]]
   [pfo.auth.model :as auth-model]
   [ajax.json :refer [json-request-format]]
   [promesa.core :as p]
   [pfo.chat.model :as model]
   [pfo.download :as download]
   [keechma.next.controller :as ctrl]
   [pfo.util :as util]))

(derive :chat-init :keechma/controller)
(defmethod ctrl/handle :chat-init
  [{:keys [state*] :as ctrl} event {:keys [conversation-id on-success on-error errors-atom]}]
  (case event
    :load (->> (model/chat-init conversation-id)
               (p/map
                (fn [response]
                  (ctrl/transact ctrl #(reset! state* response))
                  (some-> on-success (apply [response]))))
               (p/error (or on-error (fn [error-response] (throw error-response))))
               (process-error errors-atom))
    :clear (reset! state* nil)
    nil))

(derive :message-send :keechma/controller)
(defmethod ctrl/handle :message-send
  [{:keys [state*] :as ctrl} event {:keys [token message upload-ids on-success on-error errors-atom]}]
  (case event
    :load (->> (model/message-send token message upload-ids)
               (p/map
                (fn [response]
                  (ctrl/transact ctrl #(reset! state* response))
                  (some-> on-success (apply [response]))))
               (p/error (or on-error (fn [error-response] (throw error-response))))
               (process-error errors-atom))
    :clear (reset! state* nil)
    nil))

(derive :upload-file :keechma/controller)
(defmethod ctrl/handle :upload-file
  [{:keys [state*] :as ctrl} event {:keys [form-data on-success on-error errors-atom]}]
  (case event
    :load (->> (model/upload-file form-data)
               (p/map
                (fn [response]
                  (ctrl/transact ctrl #(reset! state* response))
                  (some-> on-success (apply [response]))))
               (p/error (or on-error (fn [error-response] (throw error-response))))
               (process-error errors-atom))
    :clear (reset! state* nil)
    nil))

(derive :conversations :keechma/controller)
(defmethod ctrl/handle :conversations
  [{:keys [state*] :as ctrl} event {:keys [on-success on-error errors-atom]}]
  (case event
    :load (->> (model/conversations)
               (p/map
                (fn [response]
                  (ctrl/transact ctrl #(reset! state* response))
                  (some-> on-success (apply [response]))))
               (p/error (or on-error (fn [error-response] (throw error-response))))
               (process-error errors-atom))
    :clear (reset! state* nil)
    nil))

(derive :chat-messages :keechma/controller)
(defmethod ctrl/handle :chat-messages
  [{:keys [state*] :as ctrl} event {:keys [conversation-id
                                           tool-call-id
                                           on-success
                                           on-error
                                           errors-atom]}]
  (case event
    :load (->> (model/chat-messages conversation-id)
               (p/map
                (fn [response]
                  (ctrl/transact ctrl #(reset! state* response))
                  (some-> on-success (apply [response]))))
               (p/error (or on-error (fn [error-response] (throw error-response))))
               (process-error errors-atom))
    :confirm (->>
              (api/ajaxp (str "/chat/confirm/" conversation-id)
                         {:method :post
                          :params {:tool_call_id tool-call-id}})
              (p/map
                (fn [response]
                  (some-> on-success (apply [response]))))
              (p/error (or on-error (fn [error-response] (throw error-response))))
              (process-error))
    :deny (->>
           (api/ajaxp (str "/chat/deny/" conversation-id)
                      {:method :post
                       :params {:tool_call_id tool-call-id}})
           (p/map
             (fn [response]
               (some-> on-success (apply [response]))))
           (p/error (or on-error (fn [error-response] (throw error-response))))
           (process-error))
    :clear (reset! state* nil)
    nil))

(defcontroller chat-tool-call
  [{:keys [state*] :as ctrl} event {:keys [tool-call-id args system-args success-cb]}]
  (case event
    :update-args (->>
                   (api/ajaxp (str "/chat/tool-call/" tool-call-id "/")
                     {:method :post
                      :format (json-request-format)
                      :params (cond-> {:args (into {} (util/remove-nil-values args))}
                               system-args (assoc :system_args (into {} (util/remove-nil-values system-args)))) 
                      :disable-timestamp true} )
                   (p/map (fn [response]
                            (some-> success-cb (apply [response]))))
                   (process-error))
    nil))

(derive :conversation :keechma/controller)
(defmethod ctrl/handle :conversation
  [{:keys [state*] :as ctrl} event {:keys [conversation-id conversation-name family-id collection-ids on-success on-error errors-atom]}]
  (case event
    :complete (->>
               (api/ajaxp (str "/chat/complete/" conversation-id)
                          {:method :post})
               (p/map
                (fn [response]
                  (ctrl/transact ctrl #(reset! state* response))
                  (some-> on-success (apply [response]))))
               (p/error (or on-error (fn [error-response] (throw error-response))))
               (process-error))
    :rename (->>
             (api/ajaxp (str "/chat/rename/" conversation-id)
                        {:method :post
                         :body (util/make-params
                                (util/remove-nil-values {:name conversation-name}))})
             (p/map
              (fn [response]
                (ctrl/transact ctrl #(reset! state* response))
                (some-> on-success (apply [response]))))
             (p/error (or on-error (fn [error-response] (throw error-response))))
             (process-error))
    :update-assignments (->>
                         (api/ajaxp (str "/chat/assignments/" conversation-id)
                                    {:method :post
                                     :body (util/make-params
                                            (util/remove-nil-values {:family_id family-id
                                                                     :collection_ids collection-ids}))})
                         (p/map
                          (fn [response]
                            (ctrl/transact ctrl #(reset! state* response))
                            (some-> on-success (apply [response]))))
                         (p/error (or on-error (fn [error-response] (throw error-response))))
                         (process-error))
    :clear (reset! state* nil)
    nil))

(defcontroller chat-feedback
  [_ctrl event {:keys [message-id feedback on-success on-error]}]
  (case event
    :save (->> (model/feedback-save message-id feedback)
               (p/map #(some-> on-success (apply [%])))
               (p/error on-error))
    :remove (->> (model/feedback-remove message-id)
                 (p/map #(some-> on-success (apply [%])))
                 (p/error (fn [e] (some-> on-error (apply [e])) (throw e)))
                 (process-error))
    nil))

(derive :chat-stop :keechma/controller)
(defmethod ctrl/handle :chat-stop
  [{:keys [state*] :as ctrl} event {:keys [message-id on-success on-error errors-atom]}]
  (case event
    :load (->> (api/ajaxp  "/chat/stop" {:method :post
                                         :body (util/make-params
                                                (util/remove-nil-values {:message_id message-id}))})
               (p/map
                (fn [response]
                  (ctrl/transact ctrl #(reset! state* response))
                  (some-> on-success (apply [response]))))
               (p/error (or on-error (fn [error-response] (throw error-response))))
               (process-error errors-atom))
    :clear (reset! state* nil)
    nil))


;; Saving a file AARK created (#3004). Serves the route a download link points at, which
;; is the fallback: a plain click in the chat is handled where the message is rendered.
(derive :artifact-download :keechma/controller)
(defmethod ctrl/handle :artifact-download
  [{:keys [state*] :as ctrl} event {:keys [artifact-id]}]
  (case event
    ;; No navigation on success, deliberately: a browser cancels a download it has just
    ;; been handed when the page navigates away, which is how this page used to take the
    ;; file back. The outcome goes to state and the page says so instead.
    :save (-> (download/fetch-and-save-file (str "/chat/artifact/" artifact-id "/download"))
              (.then (fn [file-name]
                       (ctrl/transact ctrl #(reset! state* {:status :saved
                                                            :file-name file-name}))))
              ;; A failure has nothing to show, and the link lives on in the reply, so a
              ;; stale one is ordinary: report it on a live page rather than leaving this
              ;; one saying it is still working.
              (.catch (fn [error-response]
                        (api/handle-error-response nil error-response nil)
                        (util/set-location "#/chat"))))
    :clear (reset! state* nil)
    nil))
